// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description-box[data-v-470c80a4]{background-color:orange;padding:10px;border-radius:15px;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
